import { Analytics } from '@vercel/analytics/react';
import { useConsent, getConsentSnapshot } from '../utils/consent';

export const ConsentAwareAnalytics = () => {
  const consent = useConsent();
  return consent.analytics === true
    ? <Analytics beforeSend={event => getConsentSnapshot().analytics === true ? event : null} />
    : null;
};

export default ConsentAwareAnalytics;
